const RemoveIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="#5C5C5C"
        fillRule="evenodd"
        d="m7 8.238 3.094 3.094a.876.876 0 0 0 1.238-1.238L8.237 7l3.094-3.093a.875.875 0 0 0-1.238-1.237L7 5.763 3.907 2.67a.875.875 0 1 0-1.238 1.236L5.764 7 2.67 10.094a.875.875 0 0 0 1.238 1.238L7 8.237Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default RemoveIcon;
